import { MUTATIONS } from './mutation-types';

export const mutations = {
  // newly created mutations
  updateSelectedProduct(state, data) {
    state.selectedProduct = data;
  },
  updateFavouriteSizes(state, data) {
    state.favouriteSizes = data;
  },
  updataProductSvg(state, data) {
    state.productSvg = data;
  },
  updateUserInfo(state, data) {
    state.userInfo = data;
  },
  updateSVGCategories(state, data) {
    state.SVGCategories = data;
  },
  updateCrop(state, data) {
    Object.assign(state.crop, data);
  },
  setAllNewPmsColors(state, data) {
    state.AllNewPmsColors = data;
  },
  updateSelection(state, data) {
    state.selection = data;
  },
  updateCMYKColor(state, data) {
    state.CMYKColor = data;
  },
  updateZoomLevel(state, data) {
    state.zoomLevel = data;
  },
  updateCanvasScroll(state, data) {
    state.canvasScrollPosition = data;
  },
  updateLeftPanelToShow(state, data) {
    state.leftPanelToShow = data;
  },
  setIsAddNewImageModal:    (state, data) => { state.isAddNewImageModal = data; },
  toggleIsAddNewImageModal: (state) => { state.isAddNewImageModal = !state.isAddNewImageModal; },
  // newly created mutations ended

  setBaseImage(state, data) {
    state.baseImage = data;
  },

  // previously used mutations by team
  setDefaultCropMarks:        (state, payload) => { state.defaultCropMarks = payload; },
  setproductfontarray:        (state, payload) => { state.productfontarray = payload; },
  setColorPickerValue:        (state, payload) => { state.colorpicker.color = payload; },
  setBankPMSColor:            (state, payload) => { state.bankPMSColor = payload; },
  setYourColor:               (state, payload) => { state.yourColor = payload; },
  setIsOpen:                  (state, payload) => { state.colorpicker.isopen = payload; },
  setImageModel:              (state, payload) => { state.isimageopen = payload; },
  setShapeModel:              (state, payload) => { state.isShapeModelOpen = payload; },
  setSizeModel:               (state, payload) => { state.isSizeModelOpen = payload; },
  setRedirectUrl:             (state, payload) => { state.redirectUrl = payload; },
  updateProductColor:         (state, payload) => { state.productColor = payload; },
  updateBankId:               (state, payload) => { state.bankId = payload; },
  updateUserId:               (state, payload) => { state.userId = payload; },
  updateAddressBoxes:         (state, payload) => { state.addressBoxes = payload; },
  updateFdicLogos:            (state, payload) => { state.fdicLogos = payload; },
  updateNcuaLogos:            (state, payload) => { state.ncuaLogos = payload; },
  updateHousingLogos:         (state, payload) => { state.housingLogos = payload; },
  updateOrderItemId:          (state, payload) => { state.orderItemId = payload; },
  setIsSavedAndClosed:        (state, payload) => { state.isSavedAndClosed = payload; },
  setUndoRedoArrayListLength: (state, payload) => { state.undoRedoArrayListLength = payload; },
  setSaveApiMethod:           (state, payload) => { state.SaveApiMethod = payload; },
  setBaseUrl:                 (state, payload) => { state.BaseUrl = payload; },
  setBMCInstance:             (state, payload) => { state.BMCInstance = payload; },
  setMovableHandle:           (state, payload) => { state.boundingBoxHandle = payload; },
  setIsUnitInInch:            (state, payload) => { state.isUnitInInch = payload; },
  setDisplayQRCodeModal:      (state, payload) => { state.displayQRCodeModal = payload; },
  setDisplayPreviewModal:     (state, payload) => { state.displayPreviewModal = payload; },
  setDisplayAddVideoModal:    (state, payload) => { state.displayAddVideoModal = payload; },
  setDisplayAddAudioModal:    (state, payload) => { state.displayAddAudioModal = payload; },
  setSVGCategoryFilter:       (state, payload) => { state.svgCategoryFilter = payload; },
  setIsLoaderVisible:         (state, payload) => { state.isLoaderVisible = payload; },
  setPreviewClicked:          (state, payload) => { state.previewClicked = payload; },
  setDisplayHelpText:         (state, payload) => { state.displayHelpText = payload; },
  changeFontFavouriteAttribute(state, data) {
    console.log('changing font', data);
    const index = state.productfontarray.findIndex(item => item.id == data.fontId);
    if (index > -1) {
      state.productfontarray[index].isFavourite = data.isFavourite;
    }
  },

  // previously used mutations by team ended

  setSelectedObjectAnimation: (state, { index, style, speed }) => {
    state.selectedProduct.pages[state.selectedPage].objectList.forEach((element, i) => {
      if (element.elementIndex == index) {
        state.selectedProduct.pages[state.selectedPage].objectList[i].animation = { style, speed };
      }
    });
  },
  removeAnimation: (state) => {
    state.selectedProduct.pages[state.selectedPage].objectList.forEach((element, i) => {
      if (element.elementIndex == state.selectedProductIndex) {
        state.selectedProduct.pages[state.selectedPage].objectList[i].animation = null;
      }
    });
  },
  setPageThumbnails: (state, { index, output }) => { // not getting used, can be deleted
    state.pageThumbnails[index] = output;
  },
  setSelectedProductIndex: (state, index) => {
    state.selectedProductIndex = index;
  },
  updateCopiedObjects(state, payload) {
    state.copiedObjects = payload;
  },
  setIsVideoModel(state, payload) {
    state.isVideoModel = payload;
  },
  setSubmittedAs(state, payload) {
    state.submittedAs = payload;
  },
  updateIsBgRemoverOpen(state, payload) {
    state.isOpenBgRemoverModal = payload;
  },
  updateBgRemoverImagesList(state, payload) {
    state.bgRemoverImagesList = payload;
  },
  updateTimeLinePercentage(state, payload) {
    state.timeLinePercentage = payload;
  }
};
